var scope_0 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/161c7fe24cab5b512b64399aa8f6b2cb.js').default;
var scope_1 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/321a1c93b3b72b61cfb597f00ae7e741.js').default;
var scope_2 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6713973961a369c80ecc356be03fb600.js').default;
var scope_3 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e7614f5a9aaa310fbf6a8f937ed5c90.js').default;
var scope_4 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e10495c65c8acacd6b1f785f5759a9c8.js').default;
var scope_5 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    